import React, { createContext, useState, useContext } from 'react';

const OnSelectMenuContext = createContext();

const SIDEBAR_COLLAPSED_KEY = 'whizr:dash-sidebar-collapsed';

function getStoredSidebarCollapsed() {
    try {
        return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === '1';
    } catch (error) {
        return false;
    }
}

export default function OnSelectMenuProvider({ children }) {
    const [onSelectMenu, setOnSelectMenu] = useState(null);
    const [isLateralMenuActive, setIsLateralMenuActive] = useState(false);
    const [isSidebarCollapsed, setIsSidebarCollapsedState] = useState(getStoredSidebarCollapsed);

    function setIsSidebarCollapsed(collapsed) {
        setIsSidebarCollapsedState(collapsed);
        try {
            localStorage.setItem(SIDEBAR_COLLAPSED_KEY, collapsed ? '1' : '0');
        } catch (error) {
            // ignore storage failures (private mode, quota, etc.)
        }
    }

    function toggleSidebarCollapsed() {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    }

    return (
        <OnSelectMenuContext.Provider value={{
            onSelectMenu,
            setOnSelectMenu,
            isLateralMenuActive,
            setIsLateralMenuActive,
            isSidebarCollapsed,
            setIsSidebarCollapsed,
            toggleSidebarCollapsed,
        }}>
            {children}
        </OnSelectMenuContext.Provider>
    );
}

export function useOnSelectMenu() {
    const context = useContext(OnSelectMenuContext);

    if (!context) throw new Error('useOnSelectMenu must be used within a OnSelectMenuProvider');

    return context;
}